import { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AuthContext.js";
import styles from "./admin.module.css";

const NAV_ITEMS = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/karten", label: "LineUp-Karten" },
  { to: "/admin/kategorien", label: "Kategorien" },
  { to: "/admin/spiele", label: "Spiel-Konfiguration" },
  { to: "/admin/seiten", label: "Seiten" },
  { to: "/admin/import-export", label: "Import/Export" },
];

export function AdminLayout() {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  async function handleLogout() {
    await logout();
    navigate("/admin/login");
  }

  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <span className={styles.brand}>Roughly Admin</span>
        <nav className={styles.nav}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end ?? false}
              className={({ isActive }) => (isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button type="button" className={styles.logoutButton} onClick={handleLogout}>
          Abmelden
        </button>
      </header>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
